"use client";
import * as React from "react";
const SvgWorkSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M17.5 3.37h-5.1V1.68A1.7 1.7 0 0 0 10.7 0H7.3c-.93 0-1.7.76-1.7 1.68v1.69H.5V16h17zm-6.8 0H7.3V1.68h3.4z" }));
export {
  SvgWorkSharp as default
};
